import { ComponentProps } from 'react';

export function QrCodeIcon({ width = 24, height = 24, ...props }: ComponentProps<'svg'>) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="1" y="1" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3.5" y="3.5" width="3" height="3" fill="currentColor" />
      <rect x="15" y="1" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="17.5" y="3.5" width="3" height="3" fill="currentColor" />
      <rect x="1" y="15" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3.5" y="17.5" width="3" height="3" fill="currentColor" />
      <rect x="15" y="15" width="3" height="3" fill="currentColor" />
      <rect x="21" y="15" width="3" height="3" fill="currentColor" />
      <rect x="15" y="21" width="3" height="3" fill="currentColor" />
      <rect x="21" y="21" width="3" height="3" fill="currentColor" />
    </svg>
  );
}
